import Drawer from "@mui/material/Drawer";
import {
  Avatar,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../styles/useButtonStyles";

import { useState, useEffect } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import axios from "axios";

import { useDispatch } from "react-redux";
import { adminActions } from "../redux/slices/adminSlice";
import { financeActions } from "../redux/slices/financeSlice";
import { loginCognitoActions } from "../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../redux/slices/memberSlice";
import { merchantActions } from "../redux/slices/merchantSlice";
import { receiptsActions } from "../redux/slices/recieptsSlice";
import { roleActions } from "../redux/slices/roleSlice";
import { salesActions } from "../redux/slices/SalesSlice";
import { shopUserActions } from "../redux/slices/shopUserSlice";
import { useAppSelector } from "../redux/hooks";
import { APIConstants } from "../constants/ApiConstants";
import MerchantProfile from "../components/merchant/MerchantProfile";
import theme from "../theme";
import BasicTextField from "../components/forms/formElements/BasicTextField";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import { adminProfile } from "../static-models/AdminProfile";
import CloseIcon from "@mui/icons-material/Close";
import { stopSession } from "../services/interceptors/ApiInterceptor";

export interface UpdateAdminProps {
  initialFormData: UpdateAdminDataType;
}
export interface UpdateAdminDataType {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  user_role: string;
  email: string;
  status: string;
  designation: String;
  department: string;
}
const paperStyle: React.CSSProperties = {
  padding: "12px",
  borderRadius: 10,
  width: "60%",
  height: "100%",
  justifyContent: "right",
  color: "#1A3263",
};

const NewProfile = (props: UpdateAdminProps) => {
  const [profileOpen, setProfileClose] = React.useState(true);
  const dispatch = useDispatch();
  const { initialFormData } = props;
  const [selectState, setSelectState] = useState("");
  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [merchant, setMerchant] = useState(false);
  const navigate = useNavigate();
  const [updateAdminFormState, setAdminFormState] =
    useState<UpdateAdminDataType>(initialFormData);
  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };
  const handleLogout = async () => {
    setLoading(true);
    resetPersistStates();
    setTimeout(() => {
      sessionStorage.clear();
      stopSession()
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  const navigateToProfile = async () => {
    navigate("/updateProfile");
  };

  const firstName = useAppSelector(
    (state: any) => state.persistReducers.login.firstName
  );
  const lastName = useAppSelector(
    (state: any) => state.persistReducers.login.lastName
  );
  const email = useAppSelector(
    (state: any) => state.persistReducers.login.email
  );
  const department = useAppSelector(
    (state: any) => state.persistReducers.login.department
  );
  const userRole = useAppSelector(
    (state: any) => state.persistReducers.login.userRole
  );
  const groups = localStorage.getItem("groups");
  const userRoleGroup = groups ? JSON.parse(groups) : [];

  useEffect(() => {
    if (userRoleGroup.find((role: any) => role.includes("merchant"))) {
      setMerchant(true);
    }
  }, []);

  return (
    <Grid
      display={"flex"}
      alignItems={"right"}
      justifyContent={"right"}
      height={"100%"}
      border={"2px solid orange"}
    >
      {/* <Paper
        style={paperStyle}
        elevation={9}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      > */}
      <Grid
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        p={5}
        sx={{
          backgroundColor: theme?.color?.background,
          borderRadius: 2,
        }}
      >
        <Grid
          display={"flex"}
          flex={1}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography
            variant="h4"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
              fontSize: theme.font?.fontSize.large,
            }}
          >
            My Profile
          </Typography>
          <IconButton>
            <CloseIcon />
          </IconButton>
        </Grid>

        <Grid
          border={theme.border?.newGreyBorder}
          sx={{ background: theme.color?.newGreyBackground }}
          borderRadius={2}
          p={4}
        >
          <Grid border={"2px solid red"} display={"flex"}>
            <Grid>
              <Avatar
                src={
                  adminProfile.adminProfileImage
                    ? adminProfile.adminProfileImage
                    : adminProfile.genericImage
                }
                sx={{ height: "64px", width: "64px" }}
              ></Avatar>
            </Grid>
            <Grid display={"flex"} flexDirection={"column"}>
              <Typography
                sx={{
                  color: theme?.color?.primary,
                  fontFamily: theme.font?.fontFamily.primary,
                  fontWeight: 200,
                }}
              >
                Name
              </Typography>
              <Typography >
              {`${firstName}`}
              </Typography>
            </Grid>
            <Grid></Grid>
            <Grid></Grid>
          </Grid>
        </Grid>
        <Grid
          display={"flex"}
          flex={9}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <Grid
            item
            display={"flex"}
            alignItems={"left"}
            width={"48px"}
            height={"48px"}
            mr={3}
          ></Grid>
          <Grid display={"flex"} flexDirection={"column"}>
            <Typography variant="h6">Name</Typography>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.slightThick,
                fontSize: theme.font?.fontSize.tableBody,
              }}
            >
              
            </Typography>
          </Grid>
          <Grid display={"flex"} flexDirection={"column"}>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 200,
              }}
            >
              Email
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 450,
              }}
            >
              {email}
            </Typography>
          </Grid>
          <Grid display={"flex"} flexDirection={"column"}>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 200,
              }}
            >
              Status
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.success,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 450,
              }}
            >
              Active
            </Typography>
          </Grid>
        </Grid>

        <Grid
          display={"flex"}
          flexDirection={"row"}
          alignItems={"space-between"}
          justifyContent={"space-between"}
          textAlign={"left"}
          sx={{
            paddingTop: 8,
            paddingBottom: 6,
          }}
        >
          <Grid item display={"flex"} mr={4}>
            <Button
              sx={{
                color: theme.color?.secondary,
              }}
              onClick={navigateToProfile}
            >
              update Profile
            </Button>
          </Grid>
          <Grid item display={"flex"}>
            <Button
              sx={{ ...buttonStyles.outlinedDanger }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {/* </Paper> */}
    </Grid>
  );
};
export default NewProfile;
